export default __webpack_public_path__ + "static/8i-d57774ea86f41a1f12fd89a702d239f6.woff";